import React, { createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setLogoutHandler } from "../utils/axiosInstance";
import { getTokenExpiration } from "../utils/jwtUtils";

export const AuthContext = createContext();
let logoutTimeout = null;

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(localStorage.getItem("isAuthenticated") === "true");
  const [loginMessage, setLoginMessage] = useState("");

  const login = () => {
    const token = localStorage.getItem("token");
    const expiration = getTokenExpiration(token);

    if (expiration) {
      const delay = expiration - Date.now();
      if (delay > 0) {
        logoutTimeout = setTimeout(() => {
          logout("Session expirée.");
        }, delay);
      }
    }

    localStorage.setItem("isAuthenticated", "true");
    setIsAuthenticated(true);
    setLoginMessage("");
  };

  const logout = (message = "Vous devez être connecté.") => {
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("token");
    setIsAuthenticated(false);
    setLoginMessage(message);
    clearTimeout(logoutTimeout);
    navigate("/");
  };

  setLogoutHandler(logout);

  useEffect(() => {
    if (isAuthenticated) login();
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, loginMessage }}>
      {children}
    </AuthContext.Provider>
  );
};
